import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { NavigationExtras, Router, UrlTree } from '@angular/router';

export enum NotificationMessageTypeEnum {
  SUCCESS = 'success',
  ERROR = 'error',
  WARN = 'warn',
  INFO = 'info'
}

export enum NotificationActionTypeEnum {
  FUNCTION,
  OBSERVABLE,
  NAVIGATION,
  CLOSE
}

export interface NotificationData {
  message: NotificationMessage;
  action?: NotificationAction;
  observer?: NotificationObserver;
}

export interface NotificationMessage {
  text: string;
  type?: NotificationMessageTypeEnum;
}

export interface NotificationAction {
  name: string;
  type: NotificationActionTypeEnum;
  function?: {
    fn: (...args: any[]) => void;
    args: any[];
  };
  observable?: Observable<any>;
  navigation?: {
    url: string | UrlTree;
    extras?: NavigationExtras;
  };
}

export interface NotificationObserver {
  observable: Observable<any>;
  successMsg: string;
  emptyMsg?: string;
  empty?: string | number;
  condition?: (string | number)[];
  limit?: (string | number)[];
  exception: (string | number)[];
  exceptionMsg: string;
}

@Component({
  selector: 'nrwl-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationData,
    public snackBarRef: MatSnackBarRef<NotificationComponent>,
    public router: Router
  ) {}

  ngOnInit() {}

  action() {
    this.dismiss();
    switch (this.data.action.type) {
      case NotificationActionTypeEnum.FUNCTION:
        this.data.action.function.fn(...this.data.action.function.args);
        break;
      case NotificationActionTypeEnum.OBSERVABLE:
        this.data.action.observable.pipe(timeout(30000)).subscribe();
        break;
      case NotificationActionTypeEnum.NAVIGATION:
        const extras: NavigationExtras = {
          ...this.data.action.navigation.extras
        };
        if (!extras.queryParamsHandling) {
          extras.queryParamsHandling = 'merge';
        }
        this.router.navigateByUrl(this.data.action.navigation.url, extras);
        break;
      case NotificationActionTypeEnum.CLOSE:
        this.snackBarRef.dismiss();
        break;
      default:
        break;
    }
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
